import { 
    RENTAL_PROPERTY_SETUP_INITIAL_DATA_ENDPOINT, 
    RENTAL_PROPERTY_SETUP_WIZARD_DATA_ENDPOINT, 
    RENTAL_PROPERTY_SETUP_DETAILS_ENDPOINT, 
    RENTAL_PROPERTY_SETUP_ADDRESS_ENDPOINT,
    RENTAL_PROPERTY_SETUP_ADDITIONAL_ENDPOINT,
    RENTAL_PROPERTY_SETUP_GALLERY_ENDPOINT,
    RENTAL_PROPERTY_SETUP_CUSTOM_ENDPOINT,
    RENTAL_PROPERTY_SETUP_ROOMTYPES_ENDPOINT,
} from '../endpoints';
import API from './../api';

export default {
    namespaced: true,
    state() {
        return {
            wizardData: null,
            initialData: null,
            additionalData: null,
            details: null,
            address: null,
            gallery: null,
            custom: null,
            states: [],
            photoPlacesOrder: [],
            photoPlacesOptions: [],
        };
    },
    getters: {
        wizardData: state => state.wizardData,
        initialData: state => state.initialData,
        additionalData: state => state.additionalData,
        roomTypesData: state => state.roomTypesData,
        details: state => state.details,
        address: state => state.address,
        gallery: state => state.gallery,
        custom: state => state.custom,
        countries: (state) => state.initialData.countries,
        states: (state) => state.states,
        photoPlacesOrder: (state) => state.photoPlacesOrder,
        photoPlacesOptions: (state) => state.photoPlacesOptions,
        thumbnailsRegenerationStatus: state =>
            state.initialData?.regeneration_status,
        canRegenerateThumbnails: state => state.initialData?.can_regenerate,
        countriesOptions: (state) => state.initialData?.countries.map(item => ({
            value: item.id,
            text: item.name
        })),
        statesOptions: state => state.states.map(item => ({
            value: item.id,
            text: item.name
        })),
        categoryOptions: state => state.initialData?.category_choices.map((c) => ({
            value: c.id,
            text: c.name,
        })),
        propertyOptions: state =>
            [{ value: '', text: 'Please select a property ...', disabled: true}].concat(
                state.initialData?.property_choices.map(c => ({
                    value: c.id,
                    text: c.name,
                }))
            ),
        addressesOptions: state => {
            if (state.initialData?.addresses?.length) {
                return state.initialData?.addresses.map(c => ({
                    value: c[0],
                    text: c[1],
                }));
            }
        },
        propertyChoices: state =>  {
            return (
                state.initialData && [
                    { value: null, text: 'Please, select a property....' },
                    ...state.initialData.property_choices.map((item) => ({
                        value: item.id,
                        text: item.name,
                    })),
                ]
            );
        },
    },
    mutations: {
        setPhotoPlacesOrder(state, value) {
            if (value === undefined) {
                return;
            }
            let placeOptions = value.map((item) => ({
                id: item.id,
                label: item.name
            }));
            placeOptions = placeOptions.concat([{ id: null, label: 'Uncategorized' }]);
            state.photoPlacesOrder = value;
            state.photoPlacesOptions = placeOptions;
        },        
        gotWizardData(state, response) {
            state.wizardData = response.data;
        },
        gotInitialData(state, response) {
            state.initialData = response.data
        },
        gotAdditionalData(state, data) {
            state.additionalData = data
        },
        gotCustom(state,data) {
            state.custom = data;
        },
        gotRoomTypesData(state, data) {
            state.roomTypesData = data
        },
        gotDetails(state, data) {
            state.details = data
        },
        gotAddress(state, data) {
            state.address = data
        },
        gotGallery(state, data) {
            state.gallery = data
        },
        gotLocations(state, data) {
            state.address.locations = data.locations
        },
        gotStates(state, data) {
            state.states = data.states
        },
        gotCanRegenerate(state, data) {
            state.initialData.can_regenerate = data
        },
        gotNewPhoto(state, data) {
            state.gallery.photos.push(data)
        },
        gotPropertyName(state, name) {
            state.wizardData.name = name
        }
    },
    actions: {
        async getWizardData({ commit }, {propertyId}) {
            const response = await API.get(RENTAL_PROPERTY_SETUP_WIZARD_DATA_ENDPOINT(propertyId))
            commit('gotWizardData', response);
            return response
        },
        async getInitialData({commit}, {propertyId}) {
            const response = await API.get(RENTAL_PROPERTY_SETUP_INITIAL_DATA_ENDPOINT(propertyId))
            commit('gotInitialData', response);
            return response
        },
        async getAdditionalData({commit}, {propertyId}) {
            const {data} = await API.get(RENTAL_PROPERTY_SETUP_ADDITIONAL_ENDPOINT(propertyId))
            commit('gotAdditionalData', data);
            return data
        },
        async getRoomTypesData({commit}, {propertyId}) {
            const {data} = await API.get(RENTAL_PROPERTY_SETUP_ROOMTYPES_ENDPOINT(propertyId))
            commit('gotRoomTypesData', data);
            return data
        },
        async getDetails({commit}, {propertyId}) {
            const {data} = await API.get(RENTAL_PROPERTY_SETUP_DETAILS_ENDPOINT(propertyId))
            const details = JSON.parse(JSON.stringify(data))
            if(details.check_in_options && details.check_in_options.category === null) {
                details.check_in_options.category = -1
            }
            commit('gotDetails', details);
            return details
        },
        async getAddress({commit}, {propertyId}) {
            const {data} = await API.get(RENTAL_PROPERTY_SETUP_ADDRESS_ENDPOINT(propertyId))
            commit('gotAddress', data);
            return data
        },
        async getGallery({commit}, {propertyId}) {
            const { data } = await API.get(RENTAL_PROPERTY_SETUP_GALLERY_ENDPOINT(propertyId));
            commit('gotGallery', data);
            return data
        },
        async getCustom({commit}, {propertyId}) {
            const { data } = await API.get(RENTAL_PROPERTY_SETUP_CUSTOM_ENDPOINT(propertyId));
            commit('gotCustom', data);
            return data
        },
        async getStates({commit}, {id}) {
            const {data} = await API.get(`/asynchronous/get-states/${id}`);
            commit('gotStates', data);
            return data
        },
        async copyLocations({ commit }, { propertyId, fromPropertyId }) {
            const { data } = await API.post(
                `${RENTAL_PROPERTY_SETUP_ADDRESS_ENDPOINT(
                    propertyId
                )}copy-locations/`,
                { property_id: fromPropertyId }
            );
            commit('gotLocations', data);
            return data;
        },
        async saveModule({commit}, data) {
           if(data.body) {
            const response = await API.post(data.endpoint, data.body)
            return response
           }
        },
    },
};
